class _textWrap {
  wraSpan(str) {
    return [...str].map((char) => {
      if (!char || !char.match(/\S/g)) {
        return char;
      } else {
        return `<span class="is-char">${char}</span>`;
      }
    }).join('');
  }
}

const textWrap = new _textWrap();

export default textWrap;